/* eslint-disable react/no-find-dom-node */ import { findDOMNode } from 'react-dom';
import { getWindow } from './../services/window';
/**
 * get Component Coordinate on current rendered page
 *
 *  origin of Coodinate (0, 0) is top left point on current rendered page
 *
 * @param componentRef: reference of tile component
 *
 * @return:
 *  The Rank of Component
 *      rank: componet ranking, or -1 if tile not found
 *      total: total number of components with same class name, or -1 if tile not found
 */ export function getComponentXYCoordinate(componentRef) {
    if (componentRef) {
        const domNode = findDOMNode(componentRef);
        if (domNode) {
            // get relative boundary position, left, right, top, bottom
            const boundingRectangle = domNode.getBoundingClientRect();
            // get relative center position
            // by adding top left point of a tile rectangle with half of width, and height respectively of tile rectangle
            const relativeCenterX = boundingRectangle.left + Math.floor(boundingRectangle.width / 2);
            const relativeCenterY = boundingRectangle.top + Math.floor(boundingRectangle.height / 2);
            // get absolute center position
            // by adding user scroll offset against origin (0, 0)
            return {
                x: relativeCenterX + getWindow().scrollX,
                y: relativeCenterY + getWindow().scrollY
            };
        }
    }
    return {
        x: -1,
        y: -1
    };
}
